import { combineReducers } from 'redux';
import { loadingBarReducer } from "react-redux-loading-bar";
import {
  DEFAULT_STATE,
  DEFAULT_STATE_FF_EF,
  PENDING,
  FULFILLED,
  REJECTED,
  LOGIN,
  GET_CSRF,
  GRID,
  CUSTOMERS,
  CUSTOMER_DELETE,
  USERS,
  USER_DELETE,
  CITY,
  STATE,
  COUNTRY,
  META_PRODUCT_TYPES,
  PRODUCT_TYPES,
  PRODUCT_TYPE,
  PRODUCT_TYPE_DELETE,
  PRODUCT_TYPE_STATUS_UPDATE,
  PRODUCTS,
  PRODUCT,
  PRODUCT_DELETE,
  PRODUCT_STATUS_UPDATE,
  PRODUCT_SELECT,
  PROJECTS,
  PROJECT,
  PROJECT_DELETE,
  PROJECT_STATUS_UPDATE,
  PROJECT_SELECT,
  POLES,
  POLE,
  POLE_DELETE,
  POLE_STATUS_UPDATE,
  POLE_SELECT,
  LAMPS,
  LAMP,
  LAMP_DELETE,
  LAMP_STATUS_UPDATE,
  LAMP_SELECT,
  FEEDERS,
  FEEDER,
  FEEDER_DELETE,
  FEEDER_STATUS_UPDATE,
  FEEDER_SELECT,
  LED_LOADS,
  LED_LOAD,
  LED_LOAD_DELETE,
  LED_LOAD_STATUS_UPDATE,
  LED_LOAD_SELECT,
  PINCODE,
  CUSTOMER,
  USER,
  CUSTOMERSELECT,
  LOCATIONCATEGORY,
  CATEGORY,
  DEVICE_SELECT,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  IMAGE_UPLOAD,
  FILE_UPLOAD,
  CUSTOMER_STATUS_UPDATE,
  SITE_STATUS_UPDATE,
  USER_STATUS_UPDATE,
  ROLE,
  ROLES,
  PERMISSION,
  PERMISSIONS,
  DEVICE,
  DEVICES,
  DEVICE_DOWNLINK,
  DEVICE_DELETE,
  DEVICE_STATUS_UPDATE,
  DEVICE_ADD,
  DEVICE_UPDATE,
  ALL_UTILITIES,
  ALL_CITIES,
  EMAIL,
  EMAILS,
  EMAIL_DELETE,
  EMAIL_STATUS_UPDATE,
  REPORT_DEVICE_INSTALLATION,
  REPORT_FAILURE_DEVICE_INSTALLATION,
  REPORT_SUCCESS_DEVICE_INSTALLATION,
  REPORT_TAMPERINGALERT,
  ADDRESS_MASTER_DATA_FROM,
  ADDRESS_MASTER_DATA_LIST,
  ADDRESS_MASTER_DATA_DELETE,
  ADDRESS_MASTER_DATA_STATUS_UPDATE,
  SMS,
  SMSS,
  SMS_DELETE,
  SMS_STATUS_UPDATE,
  DEVICE_STATUS_LIST,
  ALL_CUSTOMERS,
  DEVICES_INVENTORY,
  USER_FIELD_ENGINEERS,
  DEVICE_ASSIGN,
  FEEDER_ASSIGN,
  STATE_LIST,
  STATE_FORM,
  STATE_DELETE,
  STATE_STATUS_UPDATE,
  CITY_LIST,
  CITY_FORM,
  CITY_DELETE,
  CITY_STATUS_UPDATE,
  PINCODE_LIST,
  PINCODE_FORM,
  PINCODE_DELETE,
  PINCODE_STATUS_UPDATE,
  ROLE_TYPE,
  DEVICE_STATUS_HISTORY,
  ALL_USERS,
  SETTING,
  CUSTOMER_UTILITY_TYPE,
  LOGS,
  LOG_DELETE,
  CHANGE_PASSWORD,
  DETACH_DEVICE_FROM_PROP,
  ATTACH_DEVICE_TO_PROP,
  LOGOUT,
  USER_PROFILE,
  ALL_PINCODES,
  ALL_STATES,
  UPDATE_USER_PROFILE,
  CITY_PROFILE,
  PINCODE_PROFILE,
  STATE_PROFILE,
  COUNTRY_PROFILE,
  REPORT_FEEDER_INSTALLATION,
  REPORT_FAILURE_FEEDER_INSTALLATION,
  REPORT_SUCCESS_FEEDER_INSTALLATION,
  PROPERTY,
  PROPERTY_DELETE,
  PROPERTY_STATUS_UPDATE,
  PROPERTY_ADD,
  PROPERTY_UPDATE,
  HIERARCHY,
  PROPERTY_FIELDS,
  DEVICEHISTORY,
  DEVICEHISTORY_UPDATE,
  ONESTEP_ONBOARD_DEVICE,
  ONESTEP_ONBOARD_DEVICE_SUBMIT,
  UPDATE_PASSWORD, 
  LAMPBRAND,
  FIRMWARE,
  FIRMWARES,
  FIRMWARE_ADD,
  FIRMWARE_DELETE,
  FIRMWARE_UPDATE,
  BUILD_NUMBER_TYPES,
  REPORT_FIRMWARE_UPDATION
} from "../utility/constants";

const createReducer = (reducerName, defaultStateParam) => {
  const defaultState = defaultStateParam || DEFAULT_STATE;
  return (state = defaultState, action) => {
    switch (action.type) {
      case `${reducerName}_${PENDING}`:
      case `${reducerName}_${FULFILLED}`:
      case `${reducerName}_${REJECTED}`:
        return Object.assign({}, action.payload);
      default:
        return state;
    }
  };
};

const rootReducer = combineReducers({
  loadingBar: loadingBarReducer,
  grid: createReducer(GRID),
  login: createReducer(LOGIN, DEFAULT_STATE_FF_EF),
  getcsrf: createReducer(GET_CSRF, DEFAULT_STATE_FF_EF),
  forgotpassword: createReducer(FORGOT_PASSWORD, DEFAULT_STATE_FF_EF),
  resetpassword: createReducer(RESET_PASSWORD, DEFAULT_STATE_FF_EF),
  customers: createReducer(CUSTOMERS),
  customerDelete: createReducer(CUSTOMER_DELETE, DEFAULT_STATE_FF_EF),
  customerStatus: createReducer(CUSTOMER_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  allCustomers: createReducer(ALL_CUSTOMERS, DEFAULT_STATE_FF_EF),
  users: createReducer(USERS),
  userDelete: createReducer(USER_DELETE, DEFAULT_STATE_FF_EF),
  userStatus: createReducer(USER_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  userFieldEngineers: createReducer(USER_FIELD_ENGINEERS, DEFAULT_STATE_FF_EF),
  changePassword: createReducer(CHANGE_PASSWORD, DEFAULT_STATE_FF_EF),
  allUsers: createReducer(ALL_USERS, DEFAULT_STATE_FF_EF),
  cities: createReducer(CITY, DEFAULT_STATE_FF_EF),
  citiesProfile: createReducer(CITY_PROFILE, DEFAULT_STATE_FF_EF),
  states: createReducer(STATE, DEFAULT_STATE_FF_EF),
  statesProfile: createReducer(STATE_PROFILE, DEFAULT_STATE_FF_EF),
  countries: createReducer(COUNTRY),
  countriesProfile: createReducer(COUNTRY_PROFILE, DEFAULT_STATE_FF_EF),
  metaProductTypes: createReducer(META_PRODUCT_TYPES),
  productType: createReducer(PRODUCT_TYPE, DEFAULT_STATE_FF_EF),
  productTypes: createReducer(PRODUCT_TYPES),
  productTypeDelete: createReducer(PRODUCT_TYPE_DELETE, DEFAULT_STATE_FF_EF),
  productTypeStatus: createReducer(
    PRODUCT_TYPE_STATUS_UPDATE,
    DEFAULT_STATE_FF_EF
  ),

  pole: createReducer(POLE, DEFAULT_STATE_FF_EF),
  poles: createReducer(POLES),
  poleDelete: createReducer(POLE_DELETE, DEFAULT_STATE_FF_EF),
  poleStatus: createReducer(POLE_STATUS_UPDATE, DEFAULT_STATE_FF_EF),

  lamp: createReducer(LAMP, DEFAULT_STATE_FF_EF),
  lamps: createReducer(LAMPS),
  lampDelete: createReducer(LAMP_DELETE, DEFAULT_STATE_FF_EF),
  lampStatus: createReducer(LAMP_STATUS_UPDATE, DEFAULT_STATE_FF_EF),

  feeder: createReducer(FEEDER, DEFAULT_STATE_FF_EF),
  feeders: createReducer(FEEDERS),
  feederDelete: createReducer(FEEDER_DELETE, DEFAULT_STATE_FF_EF),
  feederStatus: createReducer(FEEDER_STATUS_UPDATE, DEFAULT_STATE_FF_EF),

  ledLoad: createReducer(LED_LOAD, DEFAULT_STATE_FF_EF),
  ledLoads: createReducer(LED_LOADS),
  ledLoadDelete: createReducer(LED_LOAD_DELETE, DEFAULT_STATE_FF_EF),
  ledLoadStatus: createReducer(LED_LOAD_STATUS_UPDATE, DEFAULT_STATE_FF_EF),

  product: createReducer(PRODUCT, DEFAULT_STATE_FF_EF),
  products: createReducer(PRODUCTS),
  productDelete: createReducer(PRODUCT_DELETE, DEFAULT_STATE_FF_EF),
  productStatus: createReducer(PRODUCT_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  projectSelect: createReducer(PROJECT_SELECT),
  productSelect: createReducer(PRODUCT_SELECT),
  project: createReducer(PROJECT, DEFAULT_STATE_FF_EF),
  projects: createReducer(PROJECTS),
  projectDelete: createReducer(PROJECT_DELETE, DEFAULT_STATE_FF_EF),
  projectStatus: createReducer(PROJECT_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  customerSelect: createReducer(CUSTOMERSELECT),
  locationCategory: createReducer(LOCATIONCATEGORY),
  category: createReducer(CATEGORY),
  lampBrand: createReducer(LAMPBRAND),
  pincodes: createReducer(PINCODE, DEFAULT_STATE_FF_EF),
  pincodesProfile: createReducer(PINCODE_PROFILE, DEFAULT_STATE_FF_EF),
  customer: createReducer(CUSTOMER, DEFAULT_STATE_FF_EF),
  user: createReducer(USER, DEFAULT_STATE_FF_EF),
  deviceSelect: createReducer(DEVICE_SELECT, DEFAULT_STATE_FF_EF),
  image: createReducer(IMAGE_UPLOAD, DEFAULT_STATE_FF_EF),
  file: createReducer(FILE_UPLOAD, DEFAULT_STATE_FF_EF),
  device: createReducer(DEVICE, DEFAULT_STATE_FF_EF),
  deviceAdd: createReducer(DEVICE_ADD, DEFAULT_STATE_FF_EF),
  deviceEdit: createReducer(DEVICE_UPDATE, DEFAULT_STATE_FF_EF),
  devices: createReducer(DEVICES),
  deviceDelete: createReducer(DEVICE_DELETE, DEFAULT_STATE_FF_EF),
  deviceStatus: createReducer(DEVICE_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  deviceStatusList: createReducer(DEVICE_STATUS_LIST),
  devicesInventory: createReducer(DEVICES_INVENTORY),
  deviceAssign: createReducer(DEVICE_ASSIGN, DEFAULT_STATE_FF_EF),
  feederAssign: createReducer(FEEDER_ASSIGN, DEFAULT_STATE_FF_EF),
  deviceStatusHistory: createReducer(
    DEVICE_STATUS_HISTORY,
    DEFAULT_STATE_FF_EF
  ),
  role: createReducer(ROLE, DEFAULT_STATE_FF_EF),
  roles: createReducer(ROLES),
  permission: createReducer(PERMISSION, DEFAULT_STATE_FF_EF),
  permissions: createReducer(PERMISSIONS, DEFAULT_STATE_FF_EF),
  allUtilities: createReducer(ALL_UTILITIES, DEFAULT_STATE_FF_EF),
  allCities: createReducer(ALL_CITIES, DEFAULT_STATE_FF_EF),
  email: createReducer(EMAIL, DEFAULT_STATE_FF_EF),
  emails: createReducer(EMAILS),
  emailDelete: createReducer(EMAIL_DELETE, DEFAULT_STATE_FF_EF),
  emailStatus: createReducer(EMAIL_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  sms: createReducer(SMS, DEFAULT_STATE_FF_EF),
  smss: createReducer(SMSS),
  smsDelete: createReducer(SMS_DELETE, DEFAULT_STATE_FF_EF),
  smsStatus: createReducer(SMS_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  reportDeviceInstallation: createReducer(REPORT_DEVICE_INSTALLATION),
  deviceFaliureInstallation: createReducer(REPORT_FAILURE_DEVICE_INSTALLATION),
  deviceSuccessInstallation: createReducer(REPORT_SUCCESS_DEVICE_INSTALLATION),
  deviceOnBoardResultData: createReducer(ONESTEP_ONBOARD_DEVICE),
  deviceOnBoardResultDataSubmit: createReducer(ONESTEP_ONBOARD_DEVICE_SUBMIT),
  reportFeederInstallation: createReducer(REPORT_FEEDER_INSTALLATION),
  feederFaliureInstallation: createReducer(REPORT_FAILURE_FEEDER_INSTALLATION),
  feederSuccessInstallation: createReducer(REPORT_SUCCESS_FEEDER_INSTALLATION),
  addressMasterDataList: createReducer(ADDRESS_MASTER_DATA_LIST),
  addressMasterDataFrom: createReducer(
    ADDRESS_MASTER_DATA_FROM,
    DEFAULT_STATE_FF_EF
  ),
  addressMasterDataDelete: createReducer(
    ADDRESS_MASTER_DATA_DELETE,
    DEFAULT_STATE_FF_EF
  ),
  addressMasterDataStatusUpdate: createReducer(
    ADDRESS_MASTER_DATA_STATUS_UPDATE,
    DEFAULT_STATE_FF_EF
  ),
  stateForm: createReducer(STATE_FORM, DEFAULT_STATE_FF_EF),
  stateList: createReducer(STATE_LIST),
  stateDelete: createReducer(STATE_DELETE, DEFAULT_STATE_FF_EF),
  stateStatus: createReducer(STATE_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  settings: createReducer(SETTING, DEFAULT_STATE_FF_EF),
  cityForm: createReducer(CITY_FORM, DEFAULT_STATE_FF_EF),
  cityList: createReducer(CITY_LIST),
  cityDelete: createReducer(CITY_DELETE, DEFAULT_STATE_FF_EF),
  cityStatus: createReducer(CITY_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  pincodeList: createReducer(PINCODE_LIST),
  pincodeForm: createReducer(PINCODE_FORM, DEFAULT_STATE_FF_EF),
  pincodeDelete: createReducer(PINCODE_DELETE, DEFAULT_STATE_FF_EF),
  pincodeStatus: createReducer(PINCODE_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  roleType: createReducer(ROLE_TYPE),
  customerUtilityType: createReducer(CUSTOMER_UTILITY_TYPE),
  logs: createReducer(LOGS),
  logDelete: createReducer(LOG_DELETE),
  allPincodes: createReducer(ALL_PINCODES, DEFAULT_STATE_FF_EF),
  allStates: createReducer(ALL_STATES, DEFAULT_STATE_FF_EF),
  logout: createReducer(LOGOUT, { logout: false }),
  userProfile: createReducer(USER_PROFILE, DEFAULT_STATE_FF_EF),
  updateUserProfile: createReducer(UPDATE_USER_PROFILE, DEFAULT_STATE_FF_EF),
  updatepasswordreq: createReducer(UPDATE_PASSWORD, DEFAULT_STATE_FF_EF),

  property: createReducer(PROPERTY, DEFAULT_STATE_FF_EF),
  propertyAdd: createReducer(PROPERTY_ADD, DEFAULT_STATE_FF_EF),
  propertyEdit: createReducer(PROPERTY_UPDATE, DEFAULT_STATE_FF_EF),
  propertyDelete: createReducer(PROPERTY_DELETE, DEFAULT_STATE_FF_EF),
  propertyStatus: createReducer(PROPERTY_STATUS_UPDATE, DEFAULT_STATE_FF_EF),
  getHierarchy: createReducer(HIERARCHY, DEFAULT_STATE_FF_EF),
  getPropertyFields: createReducer(PROPERTY_FIELDS, DEFAULT_STATE_FF_EF),

  deviceHistoryEdit: createReducer(DEVICEHISTORY_UPDATE, DEFAULT_STATE_FF_EF),
  deviceHistory: createReducer(DEVICEHISTORY, DEFAULT_STATE_FF_EF),
  //firmware
  firmware: createReducer(FIRMWARE, DEFAULT_STATE_FF_EF),
  firmwareAdd: createReducer(FIRMWARE_ADD, DEFAULT_STATE_FF_EF),
  firmwareEdit: createReducer(FIRMWARE_UPDATE, DEFAULT_STATE_FF_EF),
  firmwares: createReducer(FIRMWARES),
  firmwareDelete: createReducer(FIRMWARE_DELETE, DEFAULT_STATE_FF_EF),
  buildNumbers: createReducer(BUILD_NUMBER_TYPES,DEFAULT_STATE_FF_EF),
  reportFirmwareUpdation: createReducer(REPORT_FIRMWARE_UPDATION)
});

export default rootReducer;
